import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import {
	isUserLoggedIn,
	getUserData,
	getHomeRouteForLoggedInUser,
} from '@/auth/utils'
import apps from './routes/apps'
import dashboard from './routes/dashboard'
import pages from './routes/pages'
import system from './routes/system'
import contentManagement from './routes/content-management'
import calonAgen from './routes/calon-agen'
import order from './routes/order'
import report from './routes/report'
import serviceCenter from './routes/service-center'
import warehouse from './routes/warehouse'

Vue.use(VueRouter)

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	scrollBehavior() {
		return { x: 0, y: 0 }
	},
	routes: [
		{ path: '/', redirect: { name: 'dashboard' } },
		...apps,
		...dashboard,
		...pages,
		...system,
		...contentManagement,
		...calonAgen,
		...order,
		...report,
		...serviceCenter,
		...warehouse,
		{
			path: '*',
			redirect: 'error-404',
		},
	],
})

router.beforeEach((to, _, next) => {
	const isLoggedIn = isUserLoggedIn()

	if (!canNavigate(to)) {
		// Redirect to login if not logged in
		if (!isLoggedIn) return next({ name: 'auth-login' })

		// If logged in => not authorized
		return next({ name: 'misc-not-authorized' })
	}

	// Redirect if logged in
	if (to.meta.redirectIfLoggedIn && isLoggedIn) {
		const userData = getUserData()
		next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
	}

	return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
	// Remove initial loading
	const appLoading = document.getElementById('loading-bg')
	if (appLoading) {
		appLoading.style.display = 'none'
	}
})

export default router
